import request from '@/utils/request'
const orderURL = process.env.VUE_APP_BASE_API

export const ORDERAPI = {
  // 超级管理员-获取所有工单
  getAllAdminOrderList: (params: any) =>
    request({
      url: orderURL + 'ticket/all/list',
      method: 'get',
      params
    }),

  // 获取当前用户所有工单
  getAllOrderList: (params: any) =>
    request({
      url: orderURL + 'ticket/all',
      method: 'get',
      params
    }),

  // 发起人-获取我创建的订单
  getMyCreatedOrderList: (params: any) =>
    request({
      url: orderURL + 'ticket/my/list',
      method: 'get',
      params
    }),

  // 受理人-获取我的订单
  getMyOrderList: (params: any) =>
    request({
      url: orderURL + 'ticket/waiter/list',
      method: 'get',
      params
    }),

  // 受理工单
  acceptTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/accept',
      method: 'post',
      data,
      params
    }),

  // 驳回工单
  rejectTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/reject',
      method: 'post',
      data,
      params
    }),

  // 完成工单
  finishedTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/finish',
      method: 'post',
      data,
      params
    }),

  // 转接工单（组内）
  forwardTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/forward',
      method: 'post',
      data,
      params
    }),

  // 获取待转接群组
  getForwardGroup: (params: any) =>
    request({
      url: orderURL + 'ticket/forwardGroup',
      method: 'get',
      params
    }),

  // 工单转接（组外）
  forwardGroupTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/deptForward',
      method: 'post',
      data,
      params
    }),

  // 催单
  remindTicket: (data: any) =>
    request({
      url: orderURL + 'ticket/remind',
      method: 'post',
      data
    }),

  // 撤销工单
  cancelTicket: (data: any) =>
    request({
      url: orderURL + 'ticket/cancel',
      method: 'post',
      data
    }),
  // 标记工单
  tagTicket: (data: any) =>
    request({
      url: orderURL + 'ticket/tag',
      method: 'post',
      data
    }),
  // 工单详情
  detailTicket: (params: any) =>
    request({
      url: orderURL + 'ticket/detail',
      method: 'get',
      params
    }),

  // 工单事件
  eventsTicket: (params: any) =>
    request({
      url: orderURL + 'ticket/events',
      method: 'get',
      params
    }),

  // 满意度评价
  appraiseTicket: (data: any) =>
    request({
      url: orderURL + 'ticket/satisfication/add',
      method: 'post',
      data
    }),

  // 满意度评价查看
  appraiseResult: (params: any) =>
    request({
      url: orderURL + 'ticket/satisfication/list',
      method: 'get',
      params
    }),

  // 工单挂起原因
  getPendingReason: (params: any) =>
    request({
      url: orderURL + 'ticket/pendingReason',
      method: 'get',
      params
    }),

  // 工单挂起
  pendingTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/pending',
      method: 'post',
      params,
      data
    }),

  // 工单挂起解除
  unpendingTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/unpending',
      method: 'post',
      data,
      params
    }),
  // 更新工单类型接口
  updateTicket: (data: any, params: any) =>
    request({
      url: orderURL + 'ticket/updateTicket',
      method: 'post',
      data,
      params
    }),

  // 获取Excel下载
  getITExportExcel: (params: any) => {
    return request({
      url: orderURL + 'ticket/exportExcel',
      method: 'get',
      params,
      responseType: 'blob'
    })
  }
}
